export enum ChartAggregationCalcType {
    Cumulative = 'cumulative',
    Average = 'average',
}

export enum TooltipMouseEvent {
    Enter = 'enter',
    Leave = 'leave',
}
